/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h4: "h4",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Nothing beats testing mobile sites on actual mobile devices, but it can be really annoying to have to frequently deploy to view every small change you make.  I haven't had great success with the Andoird and Black Berry emulators on my machine. You have to install a bunch of extra stuff and it is not straight forward. The iPhone emulator is great, but I don't develop on a Mac, don't easily have access to one and don't really want one."
    }), "\n", _jsx(_components.p, {
      children: "Here are a few apps/methods for initial mobile development, but I haven't tested any HTML5 capabilities with these (except Safari)."
    }), "\n", _jsx(_components.h4, {
      children: "Safari"
    }), "\n", _jsx(_components.p, {
      children: "Totally ghetto, but this is normally what I use for testing javascript and inspecting the DOM.  The browser has a built in feature that lets you change the user agent."
    }), "\n", _jsx(_components.h4, {
      children: _jsx(_components.a, {
        href: "http://www.opera.com/developer/tools/",
        children: "Opera Mobile"
      })
    }), "\n", _jsx(_components.p, {
      children: "This is my tool of choice for checking page layouts.  It is fairly lightweight and pretty customizable on resolutions and other fun stuff like that."
    }), "\n", _jsx(_components.h4, {
      children: _jsx(_components.a, {
        href: "http://code.google.com/p/ibbdemo2/",
        children: "iBBDemo2"
      })
    }), "\n", _jsx(_components.p, {
      children: "This is an Adobe AIR app that acts as an iPhone and iPad emulator.  It is pretty nice, but I frequently find myself forgetting the commands to rotate the device and change the device from iPad to iPhone."
    }), "\n", _jsx(_components.h4, {
      children: _jsx(_components.a, {
        href: "http://create.msdn.com/en-US/",
        children: "Windows Phone 7 Emulator"
      })
    }), "\n", _jsx(_components.p, {
      children: "Fairly useful. Takes a little while to load, but is fairly nice once it is up and running."
    }), "\n", _jsx(_components.h4, {
      children: _jsx(_components.a, {
        href: "http://developer.palm.com/",
        children: "Palm Pre Emulator"
      })
    }), "\n", _jsx(_components.p, {
      children: "Runs on Virtual Box. It has been about a year since I used it though."
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
